import { Link } from "react-router-dom";
import { useFavorites, useBrowseHistory } from "@/hooks/useLocalCollections";
import { findDrama } from "@/mocks/dramas";

function timeAgo(ts: number) {
  const diff = Math.floor((Date.now() - ts) / 1000);
  if (diff < 60) return "刚刚";
  if (diff < 3600) return `${Math.floor(diff / 60)} 分钟前`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} 小时前`;
  return `${Math.floor(diff / 86400)} 天前`;
}

export default function LocalRail({ currentId }: { currentId: string }) {
  const { history, clear } = useBrowseHistory();
  const { ids } = useFavorites();

  const otherHistory = history.filter((item) => item.id !== currentId).slice(0, 4);
  const favoriteItems = ids
    .filter((id) => id !== currentId)
    .map((id) => findDrama(id))
    .filter((item) => Boolean(item))
    .slice(0, 4);

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <p className="rule-label text-foreground-500">浏览记录</p>
          {history.length > 0 ? (
            <button
              type="button"
              onClick={clear}
              className="cursor-pointer text-[11px] text-foreground-400 transition-colors hover:text-accent-700"
            >
              清除
            </button>
          ) : null}
        </div>
        {otherHistory.length === 0 ? (
          <p className="mt-3 text-xs leading-relaxed text-foreground-500">
            还没有其他浏览记录。你看过的作品会保存在这个浏览器里，方便随时回看。
          </p>
        ) : (
          <ul className="mt-2 divide-y divide-background-200">
            {otherHistory.map((item) => (
              <li key={item.id}>
                <Link to={`/detail/${item.id}`} className="group flex items-center gap-3 py-2.5">
                  <div className="h-12 w-9 shrink-0 overflow-hidden rounded bg-background-200">
                    <img
                      src={item.cover}
                      alt={`${item.title} 封面`}
                      title={`${item.title} 日本伦理剧`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-xs font-medium text-foreground-900 group-hover:text-primary-800">
                      {item.title}
                    </p>
                    <p className="mt-0.5 text-[10px] text-foreground-400">{timeAgo(item.viewedAt)}浏览</p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="rounded-lg border border-background-200 bg-secondary-50 p-5">
        <p className="rule-label text-secondary-800">我的收藏</p>
        {favoriteItems.length === 0 ? (
          <p className="mt-3 text-xs leading-relaxed text-foreground-700">
            点击页面上的收藏按钮，条目会出现在这里。收藏仅保存在本地浏览器，不会上传。
          </p>
        ) : (
          <ul className="mt-2 divide-y divide-secondary-200">
            {favoriteItems.map((item) =>
              item ? (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="flex items-center justify-between gap-3 py-2.5 text-xs text-foreground-800 hover:text-accent-700"
                  >
                    <span className="line-clamp-1">{item.title}</span>
                    <span className="shrink-0 font-label text-[10px] text-foreground-500">
                      {item.rating.toFixed(1)}
                    </span>
                  </Link>
                </li>
              ) : null
            )}
          </ul>
        )}
      </div>
    </div>
  );
}